import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { API_URL } from "../../../../constants/index";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import moment from "moment";

const MyTrainingIncentive = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("My Training Incentives"));
    fetchTrainingReport(filterFormData);

  }, []);

  const todayDate = moment().format("YYYY-MM-DD");
  const lastMonthDate = moment().subtract(1, "months").format("YYYY-MM-DD");

  const initialData = [
    { label: "Status", value: "" },
    { label: "From Date", value: moment(lastMonthDate).format("DD-MMM-YYYY") },
    { label: "To Date", value: moment(todayDate).format("DD-MMM-YYYY") },
  ]

  const [expenseData, setExpenseData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [Status, setStatus] = useState([]);
  const [filterFormData, setFilterData] = useState(initialData);
  const [apiStatus, SetApiStatus] = useState(undefined);

  const columns = {
    Employee: { text: "Employee",align:"start", visible: true },
    Client: { text: "Client", visible: true ,align:"start"},
    ProjectName: { text: "Project", visible: true ,align:"start"},
    FromDate: { text: "From", align: "center", visible: true },
    ToDate: { text: "To", align: "center", visible: true },
    IncentiveInAmount: { text: "STD. Rate", align: "end", visible: true },
    Days: { text: "#Days", align: "center", visible: true },
    IsIncludeHoliday: {
      text: "Include Holiday",
      align: "center",
      visible: true,
    },
    ClosedDate: { text: "Closed Date", align: "center", visible: true },
    CalTrainingAmount: { text: "Total Amt.", align: "center", visible: true },
    ApprovedAmount: { text: "Approved Amt.", align: "center", visible: true },
    ApplicationStatus: { text: "Status", align: "center", visible: true },
  };



  const handleChange = (e, name) => {
    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };

  const fetchTrainingReport = async (filterFormData) => {
    const statusId = filterFormData.find(o => o.label === "Status")?.value || 0;
    const fromDate = filterFormData.find(o => o.label === "From Date")?.value || lastMonthDate;
    const toDate = filterFormData.find(o => o.label === "To Date")?.value || todayDate;

    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/report/5?P_Status=${statusId
        }&P_FromDate=${moment(fromDate).format("YYYY-MM-DD")
        }&P_ToDate=${moment(toDate).format("YYYY-MM-DD")
        }`
      );
      SetApiStatus(response?.status);
      if (response.status === 200) {
        const expenseData = response?.data?.data?.header;
        setExpenseData(expenseData);
        // status list
        const statusList = Object.values(
          response?.data?.data?.status || {}
        ).map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setStatus(statusList);
      } else {
        console.error(
          "Failed to fetch Leave. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Leave:", error);
    }
  };


  const handleGetData = () => {
    fetchTrainingReport(filterFormData);
  };
  const formDatas = [
    { name: "From Date", type: "Date" },
    { name: "To Date", type: "Date" },
    { name: "Status", type: "Select", options: [...Status] },
  ];



  const handleFilterReset = () => {
    setFilterData(initialData)
    fetchTrainingReport(initialData)
  }
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={expenseData}
              columns={columns}
              itemsPerPage={10}
              isSorting={true}
              handleReset={handleFilterReset}
              showIcon1={true}
              searchTerm={searchTerm}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              setSearchTerm={setSearchTerm}
              isFilterRequired={true}
              formDatas={formDatas}
              handleGetData={handleGetData}
              handleChange={handleChange}
              filterFormData={filterFormData}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default MyTrainingIncentive;
